import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@leverege/ui-elements'
import { connect } from 'react-redux'
import { PasswordValidatorFactory } from '@leverege/api-validator'
import { Validate } from '~/utils'
import { LabelGroup, FormValidator, Flex } from '~/views'

class EditUserDialog extends React.Component {

  static contextTypes = {
    api : PropTypes.object
  }

  static propTypes = {
    onEdit : PropTypes.func
  }

  constructor( props ) {
    super( props )
    const user = props.user
    this.state = { password : '', 
                   name : user.name, 
                   email : user.email,
                   phone : user.phone }
  }

  componentDidMount() {
    const { dispatch, projectId } = this.props

    dispatch( async ( dispatch, getState, { api } ) => {
      const requirements = await api.project( projectId ).passwordRequirements().get()

      const pwValidator = PasswordValidatorFactory.create( requirements )

      const validator = FormValidator.create( this, 
        {
          password : {
            validator( v ) { 
              const result = pwValidator.validate( v )

              return result.valid
            }
          },
          email : {
            validator( v ) { return Validate.email( v ) }
          },
          phone : {
            validator( v ) { return Validate.phone( v, true ) }
          }
        }, 
        {
          onSubmit : this.onEdit
        } )

      this.setState( {
        validator
      } )
    } )
  }

  onEdit = ( ) => {
    const { user } = this.props
    let { password, name, email, phone } = this.state

    name = name && name.trim() === '' ? null : name
    phone = phone && phone.trim() === '' ? null : phone
    const edits = { email, name, phone }
    if ( password != null && password !== '' ) {
      edits.password = password
    }
    this.props.onEdit( { id : user.id, edits } )
  }

  render() {
    const { password, name, email, phone, validator } = this.state
    const { onEdit, user, show, onHide, ...rest } = this.props

    if ( !validator ) {
      return null
    }

    return (
      <Dialog.Question
        show={show}
        title="Edit User"
        okay="Save"
        onOkay={evt => validator.onSubmit( evt.sourceEvent )}
        onCancel={onHide}
        onClose={onHide}>
        <Flex variant="vSpace" align="stretch" direction="column">
          <LabelGroup>
            <label style={{ width : '6em' }}>Name</label>
            <input type="text"
              name="name" 
              className={validator.classnames( 'name' )} 
              placeholder="Name..."
              value={name}
              onChange={validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Email</label>
            <input type="text"
              name="email"
              className={validator.classnames( 'email' )} 
              placeholder="Email..."
              value={email}
              onChange={validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Phone</label>
            <input type="text"
              name="phone"
              className={validator.classnames( 'phone' )} 
              placeholder="Phone number for sms notifications..."
              value={phone}
              onChange={validator.onInputChange} />
          </LabelGroup>
          
          <LabelGroup>
            <label style={{ width : '6em' }}>Password</label>
            <input type="text"
              name="password" 
              className={validator.classnames( 'password' )} 
              placeholder="Password..."
              value={password}
              onChange={validator.onInputChange} />
          </LabelGroup>
        </Flex>
      </Dialog.Question>
    )
  }
}

export default connect( ( state ) => {
  return {

  }
} )( EditUserDialog )
